//다국어 코드
export const languageConfigList = [
  { LanguageName: 'KOR', Code: 'ko' },
  { LanguageName: 'ENG', Code: 'en' },
  { LanguageName: 'JP', Code: 'jp' },
];

export const gameProviderTypes = {
  GooglePlayStore: 'google',
  AppleAppStore: 'apple',
};

export const selectedAppInfoKey = 'selectedAppInfoKey';
